import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Cancel01Icon } from 'hugeicons-react';
import { useGetFaqByMachineQuery } from '../../../../application/features/faqs/faq-api';
import useTranslate from '../../../../localization/helpers';
import RichText from '../../../components/RichText';
var FaqsDetails = function (_a) {
    var _b;
    var isOpen = _a.isOpen, onClose = _a.onClose, machineId = _a.machineId;
    var theme = useTheme();
    var _c = useTranslate(), translate = _c.translate, tWithField = _c.tWithField;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var data = useGetFaqByMachineQuery({ machineId: machineId }).data;
    return (_jsxs(Drawer, { slotProps: {
            paper: {
                sx: {
                    width: { sm: '400px', xs: '100%' },
                    height: { sm: 'calc(100vh - 24px)', md: 'calc(100vh - 24px)', xs: '100%' },
                    overflow: 'hidden'
                }
            }
        }, anchor: isXs ? 'bottom' : isSm ? 'right' : 'right', variant: 'temporary', open: isOpen, onClose: onClose, children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    width: '100%',
                    borderRadius: '16px',
                    justifyContent: 'space-between',
                    padding: '16px 20px 16px 20px',
                    alignItems: 'center'
                }, children: [_jsx(Typography, { variant: 'h6', sx: { color: '#161C24' }, children: translate('faqs.faqDetails') }), _jsx(IconButton, { size: 'Xs', onClick: onClose, children: _jsx(Cancel01Icon, {}) })] }), _jsx(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0px 20px 0px 20px',
                    width: '100%',
                    borderRadius: '16px',
                    gap: '12px',
                    overflowY: 'auto',
                    paddingBottom: '50px'
                }, children: _jsx(Box, { sx: { width: '100%' }, children: _jsx(Box, { mt: 1, display: 'flex', flexDirection: 'column', gap: '12px', maxHeight: 'calc(100svh - 214px)', children: (data === null || data === void 0 ? void 0 : data.questionAnswers.length) ? ((_b = data === null || data === void 0 ? void 0 : data.questionAnswers) === null || _b === void 0 ? void 0 : _b.map(function (faq) { return (_jsx(Box, { children: _jsxs(Accordion, { sx: {
                                    width: '100%',
                                    zIndex: 1,
                                    boxShadow: 'none',
                                    borderTop: '1px solid rgba(145, 158, 171, 0.2)',
                                    borderBottom: '1px solid rgba(145, 158, 171, 0.2)',
                                    '&.Mui-expanded': {
                                        borderTop: 'none',
                                        borderBottom: 'none'
                                    }
                                }, disableGutters: true, children: [_jsx(AccordionSummary, { expandIcon: _jsx(Icon, { icon: 'eva:arrow-ios-downward-fill' }), sx: {
                                            backgroundColor: 'white',
                                            '.MuiAccordionSummary-content': {
                                                my: { md: 1.5, xs: 0.5 }
                                            }
                                        }, children: _jsx(Typography, { variant: 'subtitle2', children: faq.question }) }), _jsx(AccordionDetails, { children: _jsx(RichText, { content: faq.answer }) })] }) }, faq.id)); })) : (_jsx(Box, { display: 'flex', justifyContent: 'center', children: _jsx(Typography, { variant: 'body2', color: 'text.secondary', children: tWithField('validations.notFound', 'common.faqs') }) })) }) }) })] }));
};
export default FaqsDetails;
